import { Component, Injectable, Input, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../../../../../app/services/authentication.service';
import { AdministrationService } from '../../../../../../app/services/administration.service';
import { ConsumeService } from '../../../../../../app/services/consume.service';
import { AlertService } from '../../../../../../app/utils/alert.service';
import { BindComponentService } from '../../../../../../app/utils/bind.component.service';
import { SaveConsumeComponent } from '../../../../../../app/home/paraEmpresas/consume/save/content.component';
import { RemoveGroupConsumeComponent } from '../../../../../../app/home/paraEmpresas/consume/remove/content.component';
import { MoveLineConsumeComponent } from '../../../../../../app/home/paraEmpresas/consume/move/content.component';
import { MoveLineConfirmationComponent } from '../../../../../../app/home/paraEmpresas/consume/move/content.confirmation.component';
import { EditQuotaLinesComponent } from '../../../../../../app/home/paraEmpresas/consume/editQuotaLines/content.component';
import { SmsNotificationComponent } from '../../../../../../app/home/paraEmpresas/consume/voice/smsNotification/content.component';
import { EditNotifLinesComponent } from '../../../../../../app/home/paraEmpresas/consume/data/editNotifConsLines/content.component';
import { ConsumeView } from '../../../../../../app/models/consumeView.model';
import { VoiceCompanyDetail } from '../../../../../../app/models/voiceCompanyDetail.model';
import { DataPackGroup } from '../../../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../../../app/models/dataPackLine.model';
import { VoiceConsumeService } from '../../../../../../app/services/voice.consume.service';
import { DataPackValue } from '../../../../../../app/models/dataPackValue.model';
import { LoadingComponent } from '../../../../../../app/home/paraEmpresas/modalLoading/content.component';
import { Mobilesearch } from '../../../header/mobilesearch/content.component';


import * as _ from "lodash";
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap/popover/popover';
import { Lightbox } from 'angular2-lightbox';
import { VoiceConsumptionBatchProcessing } from '../../../../../models/voiceConsumptionBatchProcessing.model';
import { EditBatchQuotaComponent } from '../../../../../../app/home/paraEmpresas/consume/batch/content.component';



/**
 * @author Wesley Mascarenhas
 * @version $Id: content.component.ts 70933 2017-11-21 16:00:48Z edivaldo.m.junior $
 */
@Component({
  templateUrl: './content.template.html',
  providers: [ConsumeView],
  selector: 'consumeVoiceHibridComponent'

})
@Injectable()
export class ConsumeVoiceHibridComponent implements OnInit, AfterViewInit {


  private static readonly GROUPS_FETCH_SIZE: number = 20; //50
  private static readonly LINES_FETCH_SIZE: number = 20;  //50
  private static readonly MIN_LIMIT: number = 1;
  public images: any[];
  public view: ConsumeView;
  public groups: Array<DataPackGroup> = [];
  public filterValue: string;
  public groupEditionId: string;
  public selectAllLines: boolean;
  public checkItem: boolean;
  public editingLines: boolean;
  public hideButton: boolean = true;
  public hideLinesGroup: boolean = false;
  public originalLines: Array<DataPackLine>;
  public linesSnapshot: Array<DataPackLine>;
  public selectedLines: Map<string, DataPackLine> = new Map<string, DataPackLine>();
  public selectedGroup: DataPackGroup = new DataPackGroup();
  public groupsFetchSize: number = ConsumeVoiceHibridComponent.GROUPS_FETCH_SIZE;
  public linesFetchSize: number = ConsumeVoiceHibridComponent.LINES_FETCH_SIZE;
  public displayShowMoreGroupsButton: boolean;
  public displayShowMoreLinesButton: Map<number, boolean>;
  public sortingCriteria: string = null;
  public sortingAsc: boolean = true;
  public sortingLineCriteria: string = null;
  public sortingLineAsc: boolean = true;
  public savingLines: boolean;
  public savingLinesLimit: boolean = true;
  public savingLinesOverBalance: boolean = true;
  public savingLinesOverBalanceLimitNextCycle: boolean = true;
  public pattern: any = '^\\d+$$';
  public limitPattern: string = '^\\d+$|^$';
  public overBalanceLimitPattern = new RegExp('^\\$?(?!0.00)(([0-9]{1,3}([0-9]{3}.)*)[0-9]{3}|[0-9]{1,3})(\\,[0-9]{2})?$');
  public editingMass: boolean;
  public loggedManagerType: string;
  public lines: Array<DataPackLine> = new Array<DataPackLine>();
  public displayLines: boolean = false;
  public hasHibridService: string = 'false';
  public filtered: boolean = false;
  public isfilter: string;
  public typeValue: string;
  public currentUrl: string;
  public isloading: boolean = false;
  public page: number;
  public pageGroup: number;
  public hideShowLinesButton: boolean = true;
  public isClicked: boolean = false;
  public _album = [];

  @Input() isData: boolean;

  constructor(private router: Router,
    private voiceConsumeService: VoiceConsumeService,
    private authenticationService: AuthenticationService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private bindComponent: BindComponentService,
    private _lightbox: Lightbox) {

    this.images = [];
    this.images.push({ source: '/Portal/data/assets/images/004_default.jpg', thumbnail: '/Portal/data/assets/images/004_default.jpg', title: 'Sopranos 1' });
  }

  ngOnInit() {
    this.bindComponent.set(BindComponentService.FILTER_ACTIVE_TAB, 'CONSUME_VOICE_FILTER'); //ALTERADO
    this.router.routerState.root.queryParams.subscribe(params => {
      // Defaults to 0 if no query param provided.
      this.isfilter = params['filter'];
      this.typeValue = params['typefilter'];
    });
    this.currentUrl = this.router.url;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.onNavigationChanged(event);
      }
    });

    for (let i = 1; i <= 3; i++) {
      const src = '/Portal/data/assets/images/wisardHelp' + i + '.png';
      const caption = 'Página ' + i + ' - Vivo Gestão';
      const thumb = 'demo/img/image' + i + '-thumb.jpg';
      const album = {
        src: src,
        caption: caption,
        thumb: thumb
      };

      this._album.push(album);
    }
  }
  public openLixtBox() {
    this._lightbox.open(this._album, 0);
  }

  private onNavigationChanged(event: NavigationEnd) {
    this.currentUrl = event.url;
  }

  private doFilter() {
    this.openModalLoading();
    this.voiceConsumeService
      .countSearchLines(1, this.linesFetchSize, this.typeValue)
      .subscribe(
        data => {
          if (data['code'] != "EMPYT") {
            let modalRef = this.modalService.open(Mobilesearch);
            modalRef.componentInstance.count = data['recordCount'];
            modalRef.componentInstance.typeValue = this.typeValue;
            modalRef.componentInstance.paginationSearch = data['paginationSearch'];
            modalRef.componentInstance.isVoiceConsumption = true;
            this.typeValue = null
            this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
          } else {
            this.alertService.error("Nenhum dado encontrado!", data);
          }
        },
        err => {
          if (err['codigo'] === "EMPTY") {
            this.alertService.warn(err.result);
          }
          this.alertService.error(err.result, err);
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        }
      );
  }

  ngAfterViewInit() {
    if (this.isfilter === 'true') {
      this.filtered = true;
      this.savingLines = true;
      this.editingLines = true;
    } else {
      this.filtered = false;
      this.loadView();
    }
    this.bindComponent.subscribe(BindComponentService.LOADING_VOICE_CONSUMPTION,
      data => {
        if (data) {
          this.loadView();
        }
      }
    );
    this.bindComponent.subscribe(BindComponentService.LOADING_VOICE_CONSUMPTION_FILTER,
      data => {
        if (data.isLoadview) {
          this.isloading = data.filtered;
          this.loadView();
        }
      }
    );
    this.bindComponent.subscribe(BindComponentService.FILTER_CONSUMPTION,
      group => {
        this.groups = new Array<DataPackGroup>();
        this.groups = group;
        this.filtered = true;
      }
    );
  }

  private reset() {
    this.groups = [];
    this.filterValue = '';
    this.groupEditionId = null;
    this.selectedGroup = null;
    this.selectAllLines = false;
    this.checkItem = false;
    this.editingLines = false;
    this.hideButton = true;
    this.hideLinesGroup = false;
    this.originalLines = [];
    this.selectedLines = new Map<string, DataPackLine>();
    this.displayShowMoreGroupsButton = true;
    this.displayShowMoreLinesButton = new Map<number, boolean>();
    this.editingMass = false;
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: 'static',
      keyboard: false,
    });
  }


  private loadView() {
    this.savingLines = true;
    this.openModalLoading();
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    this.reset();
    this.view = new ConsumeView();
    this.filtered = false;
    this.pageGroup = 1;
    this.voiceConsumeService.loadView(1, this.groupsFetchSize).subscribe(
      data => {
        let value: any = data;
        this.view.voiceCompanyDetail = value;
        this.setGroups(this.view.voiceCompanyDetail.groupList, false);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.bindComponent.set(BindComponentService.COUNT_PAGINATED_GROUP, data['recordCount']);
        this.openAcctions();
      },
      err => {
        this.view.voiceCompanyDetail = new VoiceCompanyDetail();
        this.alertService.error(err.result, err);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
      }
    );
    let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    if (!isNil(data)) {
      this.isData = data['isData'];
    }
    function isNil(value) {
      return value == null;
    }
  }

  public openAcctions() {
    let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    this.loggedManagerType = data['loggedManagerType'];
  }

  private setGroups(groups: Array<DataPackGroup>, append: boolean) {
    if (!append) {
      this.groups = groups;
    } else {
      Array.prototype.push.apply(this.groups, groups);
    }
  }

  private setLines(group: DataPackGroup, lines: Array<DataPackLine>, append: boolean) {
    if (!append) {
      group.lines = lines;
    } else {
      Array.prototype.push.apply(group.lines, lines);
    }
  }

  private searchText(text: string, value: string) {
    return (text && value) ? text.toLowerCase().search(value.toLowerCase()) != -1 : false;
  }

  private toggleGroup($event, group: DataPackGroup) {
    if (group.isErrorGroup) {
      $event.stopPropagation();
      $event.preventDefault();
    }
    if (!this.filtered) {
      this.voiceConsumeService.getBatchStatus(group).subscribe(
        data => {
          this.preencherVoiceConsumptionBatchProcessing(group, data);

        },
        err => {
          this.alertService.error(err.result, err);
        }
      );
    }
    if (this.editingLines) {
      this.cancelLinesEdition(this.selectedGroup);
    }
    if (!this.selectedGroup || this.selectedGroup.id !== group.id) {
      this.page = 1;
      this.selectedGroup = group;
    } else {
      this.selectedGroup = null;
    }
    if (!_.isNil(this.selectedLines)) {
      this.selectedLines.clear();
    }
    this.selectAllLines = false;
    this.hideButton = true;
    this.hideLinesGroup = false;
    this.displayLines = true;
  }

  private preencherVoiceConsumptionBatchProcessing(group: DataPackGroup, data: any) {
    group.voiceConsumptionBatchProcessing.limitProcessingStatus = data.limitProcessingStatus;
    group.voiceConsumptionBatchProcessing.overBalanceProcessingStatus = data.overBalanceProcessingStatus;
    group.voiceConsumptionBatchProcessing.overBalanceNextCycleProcessingStatus = data.overBalanceNextCycleProcessingStatus;
    group.voiceConsumptionBatchProcessing.linesWithSuccessLimit = data.linesWithSuccessLimit;
    group.voiceConsumptionBatchProcessing.linesWithErrorLimit = data.linesWithErrorLimit;
    group.voiceConsumptionBatchProcessing.linesWithSuccessOverBalance = data.linesWithSuccessOverBalance;
    group.voiceConsumptionBatchProcessing.linesWithErrorOverBalance = data.linesWithErrorOverBalance;
    group.voiceConsumptionBatchProcessing.linesWithSuccessOverBalanceNextCycle = data.linesWithSuccessOverBalanceNextCycle;
    group.voiceConsumptionBatchProcessing.linesWithErrorOverBalanceNextCycle = data.linesWithErrorOverBalanceNextCycle;
    group.sucessEditLinesLote = Number(data.linesWithSuccessLimit) + Number(data.linesWithSuccessOverBalance) + Number(data.linesWithSuccessOverBalanceNextCycle);
    group.errorEditLinesLote = Number(data.linesWithErrorLimit) + Number(data.linesWithErrorOverBalance) + Number(data.linesWithErrorOverBalanceNextCycle);
  }

  public preencherGroups(index: number, data: DataPackGroup) {
    let group: DataPackGroup = this.groups[index];
    group.id = data.id;
    group.name = data.name;
    group.quota = data.quota;
    group.unallocatedQuota = data.unallocatedQuota;
    group.allocateQuota = data.allocateQuota
    group.quotaConsume = data.quotaConsume;
    group.bonusConsume = data.bonusConsume;
    group.bonus = data.bonus;
    group.extraDataPackConsume = data.extraDataPackConsume;
    group.extraDataPack = data.extraDataPack;
    group.bisConsume = data.bisConsume;
    group.bis = data.bis;
    group.percentageConsumedBis = data.percentageConsumedBis;
    group.percentageConsumedBonus = data.percentageConsumedBonus;
    group.percentageConsumedExtraDataPack = data.percentageConsumedExtraDataPack;
    group.percentageConsumedQuota = data.percentageConsumedQuota;
    group.isData = data.isData;
    group.groupDefault = data.groupDefault;
    group.manager = data.manager;
    group.lines = data.lines;
    group.totalLines = data.totalLines;
    group.totalOfUnidentifiedLines = data.totalOfUnidentifiedLines;
    group.totalOfRowsWithoutQuota = data.totalOfRowsWithoutQuota;
    group.totalOfRowsOutOfQuota = data.totalOfRowsOutOfQuota;
    group.totalOfRowsOutOflimit = data.totalOfRowsOutOflimit;
    group.totalOfRowsOutOfOverBalancelimit = data.totalOfRowsOutOfOverBalancelimit;
    group.dataNotificationsCount = data.dataNotificationsCount;
    group.voiceNotificationsCount = data.voiceNotificationsCount;
    group.limit = data.limit;
    group.consumedLimit = data.consumedLimit;
    group.availableLimit = data.availableLimit;
    group.overBalanceLimit = data.overBalanceLimit;
    group.consumedOverBalanceLimit = data.consumedOverBalanceLimit;
    group.availableOverBalance = data.availableOverBalance;
    group.percentageConsumedOverBalanceLimit = data.percentageConsumedOverBalanceLimit;
    group.overBalanceLimitNextCycleControll = data.overBalanceLimitNextCycleControll;
    group.overBalanceLocalsLimit = data.overBalanceLocalsLimit;
    group.consumedOverBalanceLocalsLimit = data.consumedOverBalanceLocalsLimit;
    group.availableOverBalanceLocals = data.availableOverBalanceLocals;
    group.percentageConsumedOverBalanceLocalsLimit = data.percentageConsumedOverBalanceLocalsLimit;
    group.overBalanceLocalsLimitNextCycleControll = data.overBalanceLocalsLimitNextCycleControll;
    group.overBalanceAllCallsLimit = data.overBalanceAllCallsLimit;
    group.consumedOverBalanceAllCallsLimit = data.consumedOverBalanceAllCallsLimit;
    group.availableOverBalanceAllCalls = data.availableOverBalanceAllCalls;
    group.percentageConsumedOverBalanceAllCallsLimit = data.percentageConsumedOverBalanceAllCallsLimit;
    group.overBalanceAllCallsLimitNextCycleControll = data.overBalanceAllCallsLimitNextCycleControll;
    group.voiceConsumptionBatchProcessing = data.voiceConsumptionBatchProcessing;
  }

  private selectAll($event) {
    this.selectedLines.clear();
    this.selectAllLines = $event.srcElement.checked;
  }

  private selectOne($event, line: DataPackLine) {
    this.isClicked = false;
    this.checkItem = true;
    if ($event.srcElement.checked == true) {
      this.selectedLines.set(line.lineNumber, line);
      if (this.selectedLines.size >= 2) {
        this.editingMass = true;
      } else {
        this.editingMass = false;
      }
    } else {
      this.selectedLines.delete(line.lineNumber);
      if (this.selectedLines.size < 2) {
        this.editingMass = false;
      }
    }
  }

  private canCreateGroup(): boolean {
    return this.authenticationService.authenticatedUser;
  }

  private formatIntegerValue(val: string): string {
    return (!_.isNil(val) && val !== undefined && !_.eq(val, "-----")) ?
      Math.floor(_.toNumber(val.replace(',', '.'))).toString() : "-----";
  }

  private openEditModal(group: DataPackGroup, VoiceCompanyDetail: string) {
    let modalRef = this.modalService.open(SaveConsumeComponent);
    modalRef.componentInstance.mode = 'edition';
    modalRef.componentInstance.model = { group: group, managersList: this.view.voiceCompanyDetail.managersList, franchiseAvailableVoice: this.view.voiceCompanyDetail.franchiseAvailableVoice };
    modalRef.componentInstance.voiceFranchiseConsumptionContracted = VoiceCompanyDetail;
    modalRef.componentInstance.hasOverBalanceMonetaryVoice = this.view.voiceCompanyDetail.hasOverBalanceMonetaryVoice;
    modalRef.componentInstance.hasHibridService = this.view.voiceCompanyDetail.hasHibridService;
    modalRef.componentInstance.isConsumedVoice = true;
    modalRef.componentInstance.isCreateGroup = false;
    modalRef.componentInstance.isContextVoice = true;
    modalRef.result.then(result => this.loadView(), reason => null);
  }

  private openRemoveModal(group: DataPackGroup) {
    if (Number(group.totalLines) > 0) {
      this.alertService.error('Grupo tem linhas associadas', null);
    } else {
      let modalRef = this.modalService.open(RemoveGroupConsumeComponent);
      modalRef.componentInstance.group = group;
      modalRef.result.then(result => this.loadView(), reason => null);
    }
  }

  private openMoveLinesModal() {
    this.isClicked = true;
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    if (this.selectedLines.size == 0) {
      this.alertService.warn('Selecione pelo menos uma linha');
      return;
    }
    let payload: any = {
      startRow: 1,
      fetchSize: 10,
      action: 'getGroupMoveLines',
      group: this.selectedGroup,
      hasOverBalanceMonetaryVoice: this.view.voiceCompanyDetail.hasOverBalanceMonetaryVoice,
      hasHibridService: this.view.voiceCompanyDetail.hasHibridService
    }
    this.voiceConsumeService.getGroupMoveLines(payload).subscribe(
      data => {
        let groups: Array<DataPackGroup> = data['groupList'];
        let modalRef = this.modalService.open(MoveLineConsumeComponent);
        modalRef.componentInstance.selectedGroup = this.selectedGroup;
        modalRef.componentInstance.groups = groups;
        modalRef.componentInstance.count = data['recordCount'];
        modalRef.componentInstance.lines = this.selectedLines;
        modalRef.componentInstance.isConsumeVoice = true;
        modalRef.componentInstance.hasOverBalanceMonetaryVoice = this.view.voiceCompanyDetail.hasOverBalanceMonetaryVoice;
        modalRef.componentInstance.hasHibridService = this.view.voiceCompanyDetail.hasHibridService;
        modalRef.result.then(result => this.openConfirmationIfNeeded(result), reason => null);
        this.isClicked = false;
      },
      err => {
        this.isClicked = false;
      }
    );
    let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    this.isData = data['isData'];
  }

  private ConfigureLimitAndExceedInBatch(group: DataPackGroup) {

    this.voiceConsumeService.getBatchStatus(group).subscribe(
      data => {
        this.preencherVoiceConsumptionBatchProcessing(group, data);
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );

    if (this.getProcessStatus(group) === 'PENDING') {
      this.alertService.error('Existe um processo pendente, por favor aguarde!', null);
      return;
    } else {
      let modalRef = this.modalService.open(EditBatchQuotaComponent);
      modalRef.componentInstance.selectedGroup = this.selectedGroup;
      modalRef.componentInstance.hasHibridService = this.view.voiceCompanyDetail.hasHibridService;
    }


  }

  private editQuotaLinesModal() {
    if (this.selectedLines.size == 0) {
      this.alertService.warn('Selecione pelo menos uma linha');
      return;
    }
    let hasCallCtrlSRV = true;
    this.selectedLines.forEach((lines: DataPackLine, key: String) => {
      if (!lines.hasCallCtrl && hasCallCtrlSRV) {
        hasCallCtrlSRV = false;
      }
    });
    if (hasCallCtrlSRV) {
      let modalRef = this.modalService.open(EditQuotaLinesComponent);
      modalRef.componentInstance.selectedGroup = this.selectedGroup;
      modalRef.componentInstance.selectedLines = this.selectedLines;
      modalRef.componentInstance.isConsumeVoice = true;
      modalRef.componentInstance.isEditingOverBalance = false;
      modalRef.result.then(result => this.loadView(), reason => null);
    } else {
      this.alertService.error('Operação não permitida. Existe uma ou mais linhas que não possuem  serviço de controle de consumo.', null);
    }
  }

  private editOverBalanceMassModal() {
    if (this.selectedLines.size == 0) {
      this.alertService.warn('Selecione pelo menos uma linha');
      return;
    }
    let hasCallCtrlSRV = true;
    this.selectedLines.forEach((value: DataPackLine, key: String) => {
      if (!value.hasCallCtrl && hasCallCtrlSRV) {
        hasCallCtrlSRV = false;
      }
    });
    if (hasCallCtrlSRV) {
      let modalRef = this.modalService.open(EditQuotaLinesComponent);
      modalRef.componentInstance.selectedGroup = this.selectedGroup;
      modalRef.componentInstance.selectedLines = this.selectedLines;
      modalRef.componentInstance.isConsumeVoice = true;
      modalRef.componentInstance.isEditingOverBalance = true;
      modalRef.componentInstance.hasOverBalanceMonetaryVoice = this.view.voiceCompanyDetail.hasOverBalanceMonetaryVoice;
      modalRef.componentInstance.hasHibridService = this.view.voiceCompanyDetail.hasHibridService;
      modalRef.result.then(result => this.loadView(), reason => null);
    } else {
      this.alertService.error('Operação não permitida. Existe uma ou mais linhas que não possuem  serviço de controle de consumo.', null);
    }
  }

  private activeSmsNotificationModal() {
    let modalRef = this.modalService.open(SmsNotificationComponent);
    modalRef.result.then(result => this.loadView(), reason => null);
  }

  private openConfirmationIfNeeded(result) {
    if (result && result.question == true) {
      let modalRef = this.modalService.open(MoveLineConfirmationComponent);
      modalRef.componentInstance.selectedGroup = this.selectedGroup;
      modalRef.componentInstance.groups = this.view.voiceCompanyDetail.groupList;
      modalRef.componentInstance.lines = this.selectedLines;
      modalRef.componentInstance.message = result.message;
      modalRef.componentInstance.destinationGroupId = result.destinationGroupId;
      modalRef.result.then(result => this.loadView(), reason => null);
    } else {
      this.loadView();
    }
  }

  private editLines(group: DataPackGroup) {
    this.editingLines = true;
    this.preventNullLimit(group);
    this.originalLines = _.cloneDeep(group.lines);
    this.linesSnapshot = _.cloneDeep(group.lines);
  }

  private cancelLinesEdition(group: DataPackGroup) {
    this.editingLines = false;
    group.lines = this.originalLines;
  }

  private saveLines(group: DataPackGroup) {
    this.savingLines = false;
    let payload = {
      action: 'saveLines',
      sourceGroup: {
        id: group.id
      },
      lines: [],
      hasOverBalanceMonetaryVoice: this.view.voiceCompanyDetail.hasOverBalanceMonetaryVoice
    };
    let linesLimit: number = 0;
    let isLinesLimitInvalid: boolean = false;
    let isNameLinesInvalid: boolean = false;
    group.lines.forEach((line: DataPackLine) => {
      if(!isNameLinesInvalid){
      let limit: number = (!_.isNil(line.limit.value) && line.limit.value !== '') ? _.toNumber(line.limit.value) : 0;
      let userName: string = !_.isNil(line.userName)? line.userName :'';
      linesLimit = linesLimit + limit;
      line.overBalanceLimit.value = this.commaToDot(line.overBalanceLimit.value);
      line.overBalanceLimitNextCycleControll.value = this.commaToDot(line.overBalanceLimitNextCycleControll.value);

      if(userName !='' && userName.length > 80){
        isNameLinesInvalid = true;
      }

      payload.lines.push({
        account: line.account,
        lineNumber: line.lineNumber,
        userName: line.userName,
        limit: line.limit,
        overBalanceLimit: line.overBalanceLimit,
        overBalanceLimitNextCycleControll: line.overBalanceLimitNextCycleControll,
        overBalanceLocalsLimit: line.overBalanceLocalsLimit,
        overBalanceLocalsLimitNextCycleControll: line.overBalanceLocalsLimitNextCycleControll,
        overBalanceAllCallsLimit: line.overBalanceAllCallsLimit,
        overBalanceAllCallsLimitNextCycleControll: line.overBalanceAllCallsLimitNextCycleControll,
        blockConsumptionStatus: line.blockConsumptionStatus,
        notifyManagerGroup: line.notifyManagerGroup,
        hasCallCtrl: line.hasCallCtrl
      });
    }
    });
    if (isNameLinesInvalid){
      this.savingLines=true;
      this.alertService.error('O nome da linha deve possuir até 80 caracteres.', null);
    }else {
      this.voiceConsumeService.save(payload).subscribe(
        data => {
          this.savingLines = false;
          this.editingLines = false;
          this.originalLines = null;
          this.alertService.success(data['result']);
          this.loadView();
        },
        err => {
          this.savingLines = false;
          this.alertService.error(err.result, err);
          this.cancelLinesEdition(group);
        }
      );
    }
  }

  private isLineLimitValueValid(value: string) {
    return /^\d+$/.test(value);
  }

  private isNil(value: any) {
    return _.isNil(value);
  }

  private showMoreGroups(): void {
    this.openModalLoading();
    let hasOverBalanceMonetaryVoice = this.view.voiceCompanyDetail.hasOverBalanceMonetaryVoice;
    let hasHibridService = this.view.voiceCompanyDetail.hasHibridService;
    this.pageGroup = this.pageGroup + 1;
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    this.voiceConsumeService.loadGroups(this.pageGroup, this.groupsFetchSize, hasOverBalanceMonetaryVoice, hasHibridService).subscribe(
      data => {
        this.view.voiceCompanyDetail.groupList = data['groupList'];
        this.setGroups(this.view.voiceCompanyDetail.groupList, true);
        if (data['groupList'].length < this.groupsFetchSize) {
          this.displayShowMoreGroupsButton = false;
        }
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private showMoreLines(group: DataPackGroup, index: number): void {
    this.openModalLoading();
    this.page = this.page + 1;
    let groupLinesClone = _.cloneDeep(group.lines);
    let hideShowLinesButton = Number(group.totalLines);
    let hasOverBalanceMonetaryVoice = this.view.voiceCompanyDetail.hasOverBalanceMonetaryVoice;
    let hasHibridService = this.view.voiceCompanyDetail.hasHibridService;
    this.voiceConsumeService.loadingLines(group, this.page, this.linesFetchSize, hasOverBalanceMonetaryVoice, hasHibridService).subscribe(
      data => {
        let dados: any = data;
        let lines: Array<DataPackLine> = dados.lines;
        if (lines.length <= 0) {
          this.alertService.warn("Não existe mais linhas a serem carregadas para esse grupo.");
        }
        this.preencherGroups(index, dados);
        if (dados.lines.length < this.linesFetchSize) {
          this.displayShowMoreLinesButton[group.id] = false;
        }
        Array.prototype.push.apply(groupLinesClone, group.lines);
        group.lines = groupLinesClone;
        if (group.lines.length === hideShowLinesButton) {
          this.hideShowLinesButton = false;
        }
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private sortColumn(column: string) {
    this.sortingAsc = this.sortingCriteria == column ? !this.sortingAsc : true;
    this.sortingCriteria = column;
    this.groups = _.orderBy(this.groups, [this.sortingCriteria], [this.sortingAsc ? 'asc' : 'desc']);
  }

  private sortLineColumn(group: DataPackGroup, column: string) {
    this.sortingLineAsc = this.sortingLineCriteria == column ? !this.sortingLineAsc : true;
    this.sortingLineCriteria = column;
    group.lines = _.orderBy(group.lines, [this.sortingLineCriteria], [this.sortingLineAsc ? 'asc' : 'desc']);
  }

  private updateLimit(group: DataPackGroup, line: DataPackLine) {
    if (line.limit.value.indexOf(',')) {
      line.limit.value = line.limit.value.replace(',', '.');
    }
    let lineSnapshot = _.find(this.linesSnapshot, ['lineNumber', line.lineNumber]);
    let patt = new RegExp(this.limitPattern);
    if (patt.test(line.limit.value)) {
      if (line.limit.value) {
        if (Number(line.consumedLimit.value) > Number(line.limit.value)) {
          line.limit.value = lineSnapshot.limit.value;
          this.alertService.error('O valor do limite deve ser superior ao valor já consumido. Por favor reveja as configurações.', null);
          this.savingLinesLimit = false;
        } else if (Number(line.limit.value) > Number(group.limit.value)) {
          line.limit.value = lineSnapshot.limit.value;
          this.alertService.error('O limite configurado para linha excede o limite que está configurado no grupo.', null);
          this.savingLinesLimit = false;
        } else {
          lineSnapshot.limit.value = line.limit.value;
          this.savingLinesLimit = true;
        }
      }
    } else {
      if (this.isBlank(line.limit.value)) {
        this.savingLinesLimit = true;
      } else {
        this.savingLinesLimit = false;
        this.alertService.error('O valor do limite deve ser preenchido apenas com caracteres válidos. Por favor reveja as configurações.', null);
      }
    }
    this.validateSaveLines();
  }

  private updateOverBalanceAllCallsLimit(group: DataPackGroup, line: DataPackLine) {
    if (line.overBalanceAllCallsLimit.value.indexOf(',')) {
      line.overBalanceAllCallsLimit.value = line.overBalanceAllCallsLimit.value.replace(',', '.');
    }
    let lineSnapshot = _.find(this.linesSnapshot, ['lineNumber', line.lineNumber]);
    let patt = new RegExp(this.limitPattern);
    if (patt.test(line.overBalanceAllCallsLimit.value)) {
      if (line.overBalanceAllCallsLimit.value) {
        if (Number(line.consumedOverBalanceAllCallsLimit.value) > Number(line.overBalanceAllCallsLimit.value)) {
          line.overBalanceAllCallsLimit.value = lineSnapshot.overBalanceAllCallsLimit.value;
          this.alertService.error('O valor do excedente todas chamadas deve ser superior ao valor já consumido. Por favor reveja as configurações.', null);
          this.savingLinesLimit = false;
        } else if (Number(line.overBalanceAllCallsLimit.value) > Number(group.overBalanceAllCallsLimit.value)) {
          line.overBalanceAllCallsLimit.value = lineSnapshot.overBalanceAllCallsLimit.value;
          this.alertService.error('O valor do excedente todas chamadas excede a franquia disponível para este grupo. Por favor reveja as configurações.', null);
          this.savingLinesLimit = false;
        } else {
          lineSnapshot.overBalanceAllCallsLimit.value = line.overBalanceAllCallsLimit.value;
          this.savingLinesLimit = true;
        }
      }
    } else {
      if (this.isBlank(line.overBalanceAllCallsLimit.value)) {
        this.savingLinesLimit = true;
      } else {
        this.savingLinesLimit = false;
        this.alertService.error('O valor do excedente todas chamadas deve ser preenchido apenas com caracteres válidos. Por favor reveja as configurações.', null);
      }
    }
    this.validateSaveLines();
  }

  private updateOverBalanceLocalsLimit(group: DataPackGroup, line: DataPackLine) {
    if (line.overBalanceLocalsLimit.value.indexOf(',')) {
      line.overBalanceLocalsLimit.value = line.overBalanceLocalsLimit.value.replace(',', '.');
    }
    let lineSnapshot = _.find(this.linesSnapshot, ['lineNumber', line.lineNumber]);
    let patt = new RegExp(this.limitPattern);
    if (patt.test(line.overBalanceLocalsLimit.value)) {
      if (line.overBalanceLocalsLimit.value) {
        if (Number(line.consumedOverBalanceLocalsLimit.value) > Number(line.overBalanceLocalsLimit.value)) {
          line.overBalanceLocalsLimit.value = lineSnapshot.overBalanceLocalsLimit.value;
          this.alertService.error('O valor do excedente locais deve ser superior ao valor já consumido. Por favor reveja as configurações.', null);
          this.savingLinesLimit = false;
        } else if (Number(line.overBalanceLocalsLimit.value) > Number(group.overBalanceLocalsLimit.value)) {
          line.overBalanceLocalsLimit.value = lineSnapshot.overBalanceLocalsLimit.value;
          this.alertService.error('O valor do excedente locais excede a franquia disponível para este grupo. Por favor reveja as configurações.', null);
          this.savingLinesLimit = false;
        } else {
          lineSnapshot.overBalanceLocalsLimit.value = line.overBalanceLocalsLimit.value;
          this.savingLinesLimit = true;
        }
      }
    } else {
      if (this.isBlank(line.overBalanceLocalsLimit.value)) {
        this.savingLinesLimit = true;
      } else {
        this.savingLinesLimit = false;
        this.alertService.error('O valor do excedente locais deve ser preenchido apenas com caracteres válidos. Por favor reveja as configurações.', null);
      }
    }
    this.validateSaveLines();
  }

  private updateOverBalanceLimit(group: DataPackGroup, line: DataPackLine, $event) {
    let patt = new RegExp(this.overBalanceLimitPattern);
    let lineSnapshot = _.find(this.linesSnapshot, ['lineNumber', line.lineNumber]);
    if (Number(line.overBalanceLimit.value) > Number(group.overBalanceLimit.value)) {
      line.overBalanceLimit.value = lineSnapshot.overBalanceLimit.value;
      this.alertService.error('O limite configurado para linha excede o limite que está configurado no grupo.', null);
      this.savingLinesOverBalance = false;
    } else {
      if (patt.test(line.overBalanceLimit.value)) {
        this.savingLinesOverBalance = true;
      } else {
        if (this.isBlank(line.overBalanceLimit.value)) {
          this.savingLinesOverBalance = true;
        } else {
          this.savingLinesOverBalance = false;
          this.alertService.error('O valor do excedente deve ser preenchido apenas com caracteres válidos. Ex: 1000 ', null);

          if ($event && $event.type === 'blur') {
            $event.srcElement.focus();
          }
        }
      }
      this.validateSaveLines();
    }
  }


  private updateNextCycleOverBalanceLimit(group: DataPackGroup, line: DataPackLine, $event) {
    let patt = new RegExp(this.overBalanceLimitPattern);
    let lineSnapshot = _.find(this.linesSnapshot, ['lineNumber', line.lineNumber]);
    if (Number(line.overBalanceLimitNextCycleControll.value) > Number(group.overBalanceLimitNextCycleControll.value)) {
      line.overBalanceLimitNextCycleControll.value = lineSnapshot.overBalanceLimitNextCycleControll.value;
      this.alertService.error('O limite configurado para linha excede o limite que está configurado no grupo.', null);
      this.savingLinesOverBalance = false;
    } else {
      if (patt.test(line.overBalanceLimitNextCycleControll.value)) {
        this.savingLinesOverBalance = true;
      } else {
        if (this.isBlank(line.overBalanceLimitNextCycleControll.value)) {
          this.savingLinesOverBalance = true;
        } else {
          this.savingLinesOverBalance = false;
          if ($event.type === 'blur') {
            this.alertService.error('O valor do excedente deve ser preenchido apenas com caracteres válidos. Ex: 1000 ', null);
            $event.srcElement.focus();
          }
        }
      }
      this.validateSaveLines();
    }
  }

  private updateOverBalanceLimitNextCycle(group: DataPackGroup, line: DataPackLine, type: string) {
    let lineBalanceLimitValue: string = line.overBalanceAllCallsLimitNextCycleControll.value;
    let groupBalanceLimitValue: String = group.overBalanceAllCallsLimitNextCycleControll.value;
    let patt = new RegExp(this.overBalanceLimitPattern);
    let lineSnapshot = _.find(this.linesSnapshot, ['lineNumber', line.lineNumber]);
    if (Number(lineBalanceLimitValue) > Number(groupBalanceLimitValue)) {
      line.overBalanceAllCallsLimitNextCycleControll.value = lineSnapshot.overBalanceAllCallsLimitNextCycleControll.value;

      this.alertService.error('O valor do excedente configurado para linha excede o valor do excedente que está configurado no grupo.', null);
      this.savingLinesOverBalance = false;
    } else {
      if (patt.test(lineBalanceLimitValue)) {
        this.savingLinesOverBalanceLimitNextCycle = true;
      } else {
        if (this.isBlank(lineBalanceLimitValue)) {
          this.savingLinesOverBalanceLimitNextCycle = true;
        } else {
          this.savingLinesOverBalanceLimitNextCycle = false;
          //PB-204395
          this.alertService.error('O valor do excedente do prox. ciclo deve ser preenchido apenas com caracteres v\u00e1lidos. Ex: 1000,00', null);
        }
      }
      this.validateSaveLines();
    }
  }

  private validateSaveLines() {
    if (this.savingLinesLimit && this.savingLinesOverBalance && this.savingLinesOverBalanceLimitNextCycle) {
      this.savingLines = true;
    } else {
      this.savingLines = false;
    }
  }

  private isBlank(str) {
    return (!str || /^\s*$/.test(str));
  }

  private showLines(group: DataPackGroup, index: number, lineTypeFilter = 'T') {
    this.openLixtBox();
    if (!this.filtered) {
      this.openModalLoading();
      this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
      let hasOverBalanceMonetaryVoice = this.view.voiceCompanyDetail.hasOverBalanceMonetaryVoice;
      let hasHibridService = this.view.voiceCompanyDetail.hasHibridService;
      this.voiceConsumeService.loadingLines(group, 1, this.linesFetchSize, hasOverBalanceMonetaryVoice, hasHibridService, lineTypeFilter).subscribe(

        data => {
          //console.log("showLines");
          let value: any = data;
          this.preencherGroups(index, value);
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
          this.displayDivLines();
        },
        err => {
          this.alertService.error(err.result, err);
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        }
      );
    } else {
      this.displayDivLines();
    }
  }

  public displayDivLines() {
    this.editingLines = false;
    this.hideButton = false;
    this.hideLinesGroup = true;
    this.editingMass = false;
    this.selectedLines.clear();
    this.selectAllLines = false;
  }

  private hideLines(group: DataPackGroup) {
    this.editingLines = false;
    this.hideButton = true;
    this.hideLinesGroup = false;
    this.editingMass = false;
    this.selectedLines.clear();
    this.selectAllLines = false;
  }
  private showAndEditLines(group: DataPackGroup) {
    this.editingLines = false;
    this.hideButton = false;
    this.hideLinesGroup = true;
    this.editingMass = false;
    this.selectedLines.clear();
    this.selectAllLines = false;
    this.editLines(group);
  }

  private closeNotification(notification: string) {
    if (null !== document.getElementById(notification)) {
      document.getElementById(notification).style.display = "none";
    }
  }

  private activateOverbalanceNotification() {
  }

  private maskMsisdn(msisdn: string): string {
    if (_.isNil(msisdn)) {
      return '';
    }
    if (msisdn.length == 12) {
      return '('.concat(msisdn.substr(0, 3)).concat(') ').concat(msisdn.substring(3, (msisdn.length - 4))).concat('-').concat(msisdn.substr(-4, 4));
    } else if (msisdn.length == 11) {
      return '('.concat(msisdn.substr(0, 2)).concat(') ').concat(msisdn.substring(2, (msisdn.length - 4))).concat('-').concat(msisdn.substr(-4, 4));
    }
    return msisdn;
  }

  private preventNullLimit(group: DataPackGroup) {
    group.lines.forEach(line => {
      if (this.isNil(line.limit)) {
        line.limit = new DataPackValue();
        line.limit.value = '';
        line.limit.dataPackValueType = 'MIN';
      }
      if (this.isNil(line.consumedLimit)) {
        line.consumedLimit = new DataPackValue();
        line.consumedLimit.value = '';
        line.consumedLimit.dataPackValueType = 'MIN';
      }
    });
    if (this.isNil(group.limit)) {
      group.limit = new DataPackValue();
      group.limit.value = '';
      group.limit.dataPackValueType = 'MIN';
    }
    if (this.isNil(group.availableLimit)) {
      group.availableLimit = new DataPackValue();
      group.availableLimit.value = '';
      group.availableLimit.dataPackValueType = 'MIN';
    }
  }

  public isNotNullLimit(group: any) {
    return ((null != group.limit)) && (null != (group.limit.value));
  }

  private checkIlimitedGroup(group: DataPackGroup): boolean {
    return ((null == group.limit) || (null == group.limit.value));
  }

  private commaToDot(val: string): string {
    if (!_.isNil(val) && val !== undefined && val.length > 0) {
      val = val.replace(',', '.').toString();
    } else {
      val = null;
    }
    return val;
  }

  public hasOverBalanceMonetaryVoice(action: boolean) {
    return action;
  }

  public getTooltip(line: DataPackLine, p: NgbPopover) {
    if (!line.isSharedBalance) {
      return 'Linha sem pacote de Saldo compartilhado';
    } else {
      p.close();
    }
  }

  public getTooltipGroup(group: DataPackGroup, p: NgbPopover) {
    if (group.isErrorGroup) {
      return 'Ocorreu um erro inesperado no carregamento desse grupo, por favor entre em contato com administrador do sistema.';
    } else {
      p.close();
    }
  }

  public isEditLimit(line: DataPackLine) {
    return !(line.hasCallCtrl && line.isSharedBalance);
  }

  private filterLinesByType(value: string, group: DataPackGroup, index: number) {
    this.showLines(group, index, value);
  }

  private finishBatchStatus(notification: string, group: DataPackGroup) {
    this.closeNotification(notification);
    this.voiceConsumeService.finishBatchStatus(group).subscribe();//data => {},err => {}
  }

  private preventNullBatchStatus(batchStatus: string) {
    return (_.isNil(batchStatus) || batchStatus == undefined) ? 'NONE' : batchStatus;

  }

  public isPending(group: DataPackGroup): boolean {

   if (!this.filtered){
      return this.getProcessStatus(group) == 'PENDING';
   }else{
    return false;
   }
  }

  public getProcessStatus(group: DataPackGroup): string {
    if (group.voiceConsumptionBatchProcessing.limitProcessingStatus === VoiceConsumptionBatchProcessing.NONE &&
      group.voiceConsumptionBatchProcessing.overBalanceProcessingStatus === VoiceConsumptionBatchProcessing.NONE &&
      group.voiceConsumptionBatchProcessing.overBalanceNextCycleProcessingStatus === VoiceConsumptionBatchProcessing.NONE) {
      return VoiceConsumptionBatchProcessing.NONE;
    } else if (group.voiceConsumptionBatchProcessing.limitProcessingStatus === VoiceConsumptionBatchProcessing.PENDING ||
      group.voiceConsumptionBatchProcessing.overBalanceProcessingStatus === VoiceConsumptionBatchProcessing.PENDING ||
      group.voiceConsumptionBatchProcessing.overBalanceNextCycleProcessingStatus === VoiceConsumptionBatchProcessing.PENDING) {
      return VoiceConsumptionBatchProcessing.PENDING;
    } else if (group.voiceConsumptionBatchProcessing.limitProcessingStatus === VoiceConsumptionBatchProcessing.PROCESSED ||
      group.voiceConsumptionBatchProcessing.overBalanceProcessingStatus === VoiceConsumptionBatchProcessing.PROCESSED ||
      group.voiceConsumptionBatchProcessing.overBalanceNextCycleProcessingStatus === VoiceConsumptionBatchProcessing.PROCESSED) {
      return VoiceConsumptionBatchProcessing.PROCESSED;
    } else if (group.voiceConsumptionBatchProcessing.limitProcessingStatus === VoiceConsumptionBatchProcessing.FINISHED &&
      group.voiceConsumptionBatchProcessing.overBalanceProcessingStatus === VoiceConsumptionBatchProcessing.FINISHED &&
      group.voiceConsumptionBatchProcessing.overBalanceNextCycleProcessingStatus === VoiceConsumptionBatchProcessing.FINISHED) {
      return VoiceConsumptionBatchProcessing.FINISHED;
    } else {
      return null;
    }
  }
  public hasProcessing(group: DataPackGroup): boolean {
    return !(group.voiceConsumptionBatchProcessing.limitProcessingStatus === VoiceConsumptionBatchProcessing.NONE &&
      group.voiceConsumptionBatchProcessing.overBalanceProcessingStatus === VoiceConsumptionBatchProcessing.NONE &&
      group.voiceConsumptionBatchProcessing.overBalanceNextCycleProcessingStatus === VoiceConsumptionBatchProcessing.NONE);
  }

  public hasPendingProcessing(group: DataPackGroup): boolean {
    return (group.voiceConsumptionBatchProcessing.limitProcessingStatus === VoiceConsumptionBatchProcessing.PENDING ||
      group.voiceConsumptionBatchProcessing.overBalanceProcessingStatus === VoiceConsumptionBatchProcessing.PENDING ||
      group.voiceConsumptionBatchProcessing.overBalanceNextCycleProcessingStatus === VoiceConsumptionBatchProcessing.PENDING);
  }
}




// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/voice/voiceHibrid/content.component.ts